var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({class:_vm.btnClass,attrs:{"small":_vm.small,"icon":"","link":"","target":"_blank","href":_vm.link}},on),[_c('v-icon',{attrs:{"small":_vm.small}},[_vm._v("mdi-help-circle")])],1)]}}])},[_c('span',[_vm._v(" "+_vm._s(_vm.label)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }